<template>
    <layout-logged-in :doneRendering="doneRendering">
        <div class="truck-number">
            <div class="filter">
                <v-form @submit.prevent="onSubmit">
                    <v-container>
                        <v-layout row>
                            <v-flex>
                                <TextInput uppercase id="truck-number" label="Truck number (optional)" v-model="truckNumber"></TextInput>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex>
                                <div class="footer">
                                    <v-btn type="submit" color="primary">Enter</v-btn>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
            </div>
        </div>
    </layout-logged-in>
</template>

<script>

import LayoutLoggedIn from '@/components/Layout/LoggedIn'
import TextInput from '@/components/Core/Input/Text'

export default {
  components: {
    LayoutLoggedIn, TextInput
  },
  name: 'TruckNumber',
  data () {
    return {
      doneRendering: true,
      truckNumber: ''
    }
  },
  methods: {
    onSubmit (e) {
      this.$store.commit('truckNumber', this.truckNumber)
      this.$router.push('/itinerary')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
